import { zip } from "fp-ts/Array"

import type { InsetEdge } from "./getInsetEdges"
import type { InsetLinkEdge } from "./linkInsetEdges"
import { linkInsetEdges } from "./linkInsetEdges"
import { matchAdjacentPairs } from "../../matching"
import type { Edge2dComputed } from "../../mesh"

export type SerialTag = {
  alphaCode: string
  upperBound: number
  lowerBound: number
  range: number
}

export const getAlphaCode = (n: number): string => {
  const base = `ABCDEFGHIJKLMNOPQRSTUVWXYZ`
  const baseLength = base.length
  if (n < baseLength) return base[n]
  const first = Math.floor(n / baseLength)
  const second = n % baseLength

  return `${base[first]}${base[second]}`
}

export const linkAllInsetEdges = (options: {
  insetEdges: InsetEdge[]
}): {
  result: {
    insetsAndLinks: ((InsetEdge & SerialTag) | (InsetLinkEdge & SerialTag))[]
  }
  procedure: { linksBetweenInsets: Edge2dComputed[][] }
} => {
  const { insetEdges } = options
  const linksBetweenInsets = matchAdjacentPairs(insetEdges, linkInsetEdges)
  const insetsAndLinks = zip(insetEdges, linksBetweenInsets)
    .flat(2)
    .map((x, idx) => ({
      alphaCode: getAlphaCode(idx),
      upperBound: idx,
      lowerBound: idx,
      range: 0,
      ...x,
    }))

  return { result: { insetsAndLinks }, procedure: { linksBetweenInsets } }
}
